import React, { useContext } from 'react';

import { Col, Row } from 'antd';

import PortfolioValueEvolution from './PortfolioValueEvolution';
import OverviewCards from './OverviewCards';

import PriceGraph from './PriceGraph';
import {
  isPredeterminedSession,
  predeterminedDayNumber,
} from 'services';

import {
  CASH_APPROACH,
  FinancialInstrument,
  instrumentTypes,
  REAL_TIME_SCENARIO,
  selectors,
  WEALTH_MANAGEMENT,
} from 'state';
import { useSelector } from 'react-redux';
import HTMDurationBreakdown from '../../PortfolioTab/Overview/HTMDurationBreakdown';
import AFSDurationBreakdown from '../../PortfolioTab/Overview/AFSDurationBreakdown';
import { TraineeSessionContext } from '../../TraineeSessionContext';
import YieldCurveGraph from './YieldCurveGraph';
import { metricsNameDict, useMetricsData } from '../../useMetricsData';
import PlayerStrategicAssetAllocations from './PlayerStrategicAssetAllocations';

type Props = {
  instrument?: FinancialInstrument;
};

const PortfolioOverview: React.FC<Props> = ({ instrument }) => {
  const session = useSelector(selectors.activeSession);
  const traineeContext = useContext(TraineeSessionContext);
  const hasCashApproach = session.risk_approach === CASH_APPROACH;
  const hasHTM = useSelector(selectors.sessionHasHTMBonds);
  const hasAFS = useSelector(selectors.sessionHasAFSBonds);
  const hasEitherAFSorHTM = hasHTM || hasAFS;
  const modifiedDimensions = hasEitherAFSorHTM && hasCashApproach;
  const showHTMBreakDown =
    instrumentTypes[parseInt(traineeContext.instrumentType)]?.type ===
      'HTMBond' && !traineeContext.showCash;
  const showAFSBreakDown =
    instrumentTypes[parseInt(traineeContext.instrumentType)]?.type ===
      'AFSBond' && !traineeContext.showCash;

  const showYieldCurve =
    !traineeContext.showCash && session.client_money && !showAFSBreakDown;

  const metrics = useSelector(selectors.metrics);
  const showLimitMetric = session.limit_metric !== null;
  const isRealTime = session.scenario_type === REAL_TIME_SCENARIO;

  const last_metrics = useMetricsData();
  const last_limit_metric = last_metrics.find(
    item => item.key === session.limit_metric
  );
  const limit_metric_key = Object.keys(metricsNameDict).find(
    key => metricsNameDict[key].limit_index === session.limit_metric
  );
  const limitMetricData = metrics.map(
    (item: { [key: string]: any }, index) => ({
      // x: item.timestamp,
      // Predetermined: real "Day N" from the row's simulated date (frequency is vestigial there)
      x: isRealTime
        ? item.timestamp
        : isPredeterminedSession(session)
          ? predeterminedDayNumber(
              item.scenario_date ?? item.timestamp,
              session.start_date,
            )
          : index * session.frequency + 1,
      y: item[limit_metric_key || ''] as any,
    })
  );

  return (
    <Row style={{ flexFlow: 'row nowrap' }} gutter={30}>
      {/*{modifiedDimensions ? (*/}
      {/*  <Col flex="0 5 22%">*/}
      {/*    <OverviewCards />*/}
      {/*  </Col>*/}
      {/*) : (*/}
      {/*  <Col flex="0 5 50%">*/}
      {/*    <OverviewCards />*/}
      {/*  </Col>*/}
      {/*)}*/}
      <Col>
        <OverviewCards />
      </Col>

      {/*{showLimitMetric && last_limit_metric && (*/}
      {/*  <Col flex="0 1 15%">*/}
      {/*    <ThresholdChart*/}
      {/*      data={limitMetricData}*/}
      {/*      height={260}*/}
      {/*      width={330}*/}
      {/*      title={metricsNameDict[key]}*/}
      {/*    />*/}
      {/*  </Col>*/}
      {/*)}*/}

      <Col flex="0 1 22%">
        <PortfolioValueEvolution />
      </Col>
      <Col flex="0 1 24%">
        {instrument && <PriceGraph instrument={instrument} />}
      </Col>
      {session.management_type === WEALTH_MANAGEMENT && (
        <Col flex="0 1 20%">
          {/*<HTMDurationBreakdown />*/}
          <PlayerStrategicAssetAllocations />
        </Col>
      )}
      {showHTMBreakDown && (
        <Col flex="0 1 20%">
          <HTMDurationBreakdown />
        </Col>
      )}
      {showAFSBreakDown && (
        <Col flex="0 1 35%">
          <AFSDurationBreakdown height={220} />
        </Col>
      )}
      {showYieldCurve && (
        <Col flex="0 1 35%">
          <YieldCurveGraph height={260} />
        </Col>
      )}
    </Row>
  );
};

export default React.memo(
  PortfolioOverview,
  (a, b) => a.instrument?.id === b.instrument?.id
);
